import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Subscription, debounceTime } from 'rxjs';
import { columnsDef } from 'src/app/interfaces/columnsDef';
import { FormServices } from 'src/app/services/form.services';
import { SearchFieldService } from 'src/app/services/search-filed.service';


@Component({
    selector: 'search-input',
    templateUrl: './search-input.component.html',
    styleUrls: ['./search-input.component.scss'],
    standalone: false
})
export class SearchInputComponent implements OnInit, OnDestroy {

  @Input() entitydesc:string;
  @Input() entityname:string;
  @Input() placeholder:string;
  @Input() controlname:string='';
  @Input() fieldname:string='NAME'
  @Input() columndesc:string;
  @Input() form:UntypedFormGroup;
  @Input() condition:string;
  @Input() columnname:string;
  @Input() loaddesc:boolean = false;
  @Input() ignoreDefCondition = true;
  @Input()required:boolean =true;
  @Output() onchange:EventEmitter<boolean> = new EventEmitter<boolean>();

  parameters:columnsDef[]=[];
  columnDef:columnsDef;
  sub:Subscription;
  sub1:Subscription;

  constructor(private fs:FormServices, private searchServices:SearchFieldService, private cd:ChangeDetectorRef) { }
  
  ngOnDestroy(){
    if ( this.sub != null ){ this.sub.unsubscribe(); }
    if ( this.sub1 != null ){ this.sub1.unsubscribe() }
  }

  eventEdit(evento){
      this.onchange.emit(evento);
  }

  ngOnInit(): void {    

      var i:number = 1;
      var dataType  = "SEARCHREFERENCE";
      
      this.columnDef  = {
          DATATYPE:dataType,
          COLUMNDESC:this.columndesc == null? this.placeholder : this.columndesc,
          COLUMNNAME: this.controlname!= null ? this.controlname + "->"+this.fieldname :this.columnname + "->"+this.fieldname,
          PLACEHOLDER:this.placeholder == null ? this.columndesc : this.placeholder,
          IDCOLUMN:i,
          ISIDENTITY:0,
          ISREQUIRED: this.required ? 1 : 0,
          VISIBLE:1,
          LINE:0,
          CELL:0,
          tab:'sem tab',
          refName: this.columnname != null ? this.columnname : null,
          REFERENCES:[{
            CONSTRAINT_COLUMN_REF:this.columnname== null ? this.controlname : this.columnname +"->"+this.fieldname,
            CONSTRAINT_NAME:this.columnname== null ? this.controlname : this.columnname +"->"+this.fieldname
         }],
        }

        this.columnDef.ISFK = 1;
        let ob={
             RefName: this.entityname,
             RefDesc: this.entitydesc
        }
        this.columnDef.VALIDATIONERROR = JSON.stringify(ob);

        this.parameters.push(this.columnDef);
        
        this.fs.refreshForm(this.form,this.parameters,{},false);
        
        if ( this.loaddesc ){
          let columnRef:columnsDef = this.searchServices.loadRef(this.columnDef,this.parameters);
          this.searchServices.updateDesription(this.entityname,this.columnDef,columnRef,this.form,this.condition,null,null);
        }

        this.sub1 = this.form.get(this.controlname).valueChanges.pipe(debounceTime(500)).subscribe(data=>{
          if ( this.loaddesc ){
            let columnRef:columnsDef = this.searchServices.loadRef(this.columnDef,this.parameters);
            this.searchServices.updateDesription(this.entityname,this.columnDef,columnRef,this.form,this.condition,null,null);
          }   
        });

        this.cd.detectChanges();
  }

}
